import { action, observable } from 'mobx'
import { Config, IS_ELECTRON } from '../utils/config'
import { FaxLogModel } from './Page/FaxLogStore'

class AppStore {
  @observable isShowPreviewModal = false
  @observable previewUrl = ''
  // '/image_preview.html?url=https://testchfxdotcom.s3.amazonaws.com/fax_storage_upload/2021-06-24/70013f23-36d4-4d17-bac8-b57ec67d2c4d.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20210624T080442Z&X-Amz-SignedHeaders=host&X-Amz-Expires=3600&X-Amz-Credential=AKIA5VNJD3QS5HJLDCCV%2F20210624%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Signature=9538d51c383323129898352f14420b745ab64fc57ed43d0aebee5c33f4bffca8'
  @action openPreviewModal = (url: string, type = '') => {
    if (type === 'image') {
      url = '/image_preview.html?url=' + url
      if (IS_ELECTRON) {
        url = Config.appDomain + url
      }
    } else if (type === 'other') {
      // url = 'https://docs.google.com/viewer?url=' + url
      return
    }
    this.previewUrl = url
    this.isShowPreviewModal = true
  }
  @action closePreviewModal = () => {
    this.previewUrl = ''
    this.isShowPreviewModal = false
  }

  // 是否显示添加 label
  @observable isShowAddToLabel = false
  @observable labelActiveFaxLog: FaxLogModel | null = null
  @action openAddToLabel(faxLog: FaxLogModel) {
    this.labelActiveFaxLog = faxLog
    this.isShowAddToLabel = true
  }
  @action closeAddToLabel() {
    this.labelActiveFaxLog = null
    this.isShowAddToLabel = false
  }

  // 是否显示更改 note
  @observable isShowAddNote = false
  @observable noteActiveFaxLog: FaxLogModel | null = null
  @action openAddNote(faxLog: FaxLogModel) {
    this.noteActiveFaxLog = faxLog
    this.isShowAddNote = true
  }
  @action closeAddNote() {
    this.noteActiveFaxLog = null
    this.isShowAddNote = false
  }
}

export default AppStore
